import React from "react";
import CustomerProgress from "../../../components/progressBar/CustomerProgress";
import { X } from "lucide-react";

const ReviewFinish = ({
  id_R,
  closeReviewModal,
  reviewModalOpen,
  firstName,
  lastName,
  middleName,
  email,
  phoneNumber,
  dob,
  kraPin,
  monthlyIncome,
  physicalAddress,
  county,
  subCounty,
  identification,
  openAddInfoModal,
  jobTitle,
  openIDModal,
  openNextOfKin,
  fullName,
  dateOfBirth,
  relationship,
  mobileNumber,
  location,
  appendCountryCode,
  handleCompleteRegistration,
}) => {
  const handleBackButtonClick = () => {
    // Close the current modal
    closeReviewModal();

    // Open the previous modal
    openAddInfoModal();
  };

  const handleEditAddInfo = () => {
    // Close the current modal
    closeReviewModal();

    openAddInfoModal();
  };

  const handleEditIDInfo = () => {
    // Close the current modal
    closeReviewModal();

    openIDModal();
  };

  const handleEditNextOfKin = () => {
    // Close the current modal
    closeReviewModal();

    openNextOfKin();
  };

  return (
    <>
      <div
        onClick={closeReviewModal}
        id={id_R}
        className={`${
          reviewModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="relative rounded-[10px] flex h-[650px] w-[1080px] bg-white shadow"
        >
          <div
            onClick={closeReviewModal}
            className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
          >
            <X color="#ffffff" />
          </div>
          <div className="flex w-full mx-auto">
            <div className=" w-[28%] rounded-[10px] bg-[#F5F6F7]">
              <div className="pt-4 px-2 rounded-t">
                <p className="text-[20px] font-bold text-[#000] ml-5">
                  Add Member
                </p>
              </div>
              <div className="mt-[32px] px-6">
                <CustomerProgress step={7} />
              </div>
            </div>
            <div className="w-[72%] mx-[10px] flex flex-col">
              <div className="h-[85%] w-[95%]">
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Review and finish
                  </p>
                  <div className="text-[#000] mt-5 text-sm font-normal ">
                    <p>
                      Great work! You've provided all the necessary details for
                      the new customer. Take a moment to review and confirm the
                      settings below:
                    </p>
                  </div>
                </div>
                <div className="flex justify-between mt-5 w-[100%]">
                  <div className="w-[54%]">
                    <div className="w-full">
                      <p className="text-[#000] text-[16px] font-medium">
                        Personal information
                      </p>
                      <div className="flex gap-2 mt-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          First name
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {firstName}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Middle name
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {middleName}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Last name
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {lastName}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Verified Email
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {email}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Verified Phone Number
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {appendCountryCode(phoneNumber)}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Date of Birth{" "}
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {dob}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[45%]">
                    <div className="w-full">
                      <div className="w-full flex items-center justify-between">
                        <p className="text-[#000] text-[16px] font-medium">
                          Additional information
                        </p>
                        <button
                          onClick={handleEditAddInfo}
                          data-modal-toggle={id_R}
                          type="button"
                          className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                        >
                          Edit
                        </button>
                      </div>
                      <div className="flex gap-2 mt-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          KRA PIN
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {kraPin}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Monthly income
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {" "}
                          KES {monthlyIncome}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Job Title
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {" "}
                          {jobTitle}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          County
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {" "}
                          {county}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Sub-county
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {" "}
                          {subCounty}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Physical address
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {" "}
                          {physicalAddress}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-5 w-[100%]">
                  <div className="w-[54%]">
                    <div className="w-full">
                      <div className="w-[92%] flex items-center justify-between">
                        <p className="text-[#000] text-[16px] font-medium">
                          Verified Identity Information
                        </p>
                        <button
                          onClick={handleEditIDInfo}
                          data-modal-toggle={id_R}
                          type="button"
                          className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                        >
                          Edit
                        </button>
                      </div>

                      <div className="flex gap-2 mt-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          National ID Number
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {identification}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[45%]">
                    <div className="w-full">
                      <div className="w-full flex items-center justify-between">
                        <p className="text-[#000] text-[16px] font-medium">
                          Next of kin information
                        </p>
                        <button
                          onClick={handleEditNextOfKin}
                          data-modal-toggle={id_R}
                          type="button"
                          className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                        >
                          Edit
                        </button>
                      </div>

                      <div className="flex gap-2 mt-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Full Name
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {fullName}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Date of Birth
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {dateOfBirth}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Relationship
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {relationship}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Phone Number
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {mobileNumber}
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <div className="text-[#9F9F9F] text-[16px] font-[300]">
                          Location
                        </div>
                        <div className="text-[#4F4F4F] text-[16px] font-[300]">
                          {location}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex w-[95%] h-[15%] items-center justify-between">
                <div className="flex items-center justify-between w-[15vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                </div>
                <button
                  onClick={handleCompleteRegistration}
                  data-modal-toggle={id_R}
                  type="button"
                  className="text-white bg-[#074073] hover:bg-[#074073] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                >
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewFinish;
